import useSwiperRef from "../../hooks/useSwiperRef";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Pagination } from "swiper";
import "swiper/css/bundle";

import { ReactComponent as LeftCircleArrowIcon } from "../../assets/svg/left-circle-arrow.svg";
import { ReactComponent as RightCircleArrowIcon } from "../../assets/svg/right-circle-arrow.svg";

SwiperCore.use([Navigation, Pagination]);


const BannerCarousel = ({ props }) => {
  const [nextEl, nextElRef] = useSwiperRef();
  const [prevEl, prevElRef] = useSwiperRef();

  return (
    <div className="banner-with-carousel">
      <div
        className="background-banner"
        style={{
          backgroundImage: `url(
              ${process.env.PUBLIC_URL}${process.env.NODE_ENV === `production` ? `/build` : ``}${props.bannerImage}
          )`,
        }}
      />

      <div className="text-carousel">
        <Swiper
          navigation={{
            prevEl,
            nextEl,
          }}
        >
          {props.carousel.map((panel, idx) => (
            <SwiperSlide key={idx}>
              <h3>{panel.title}</h3>
              <ul className="carousel-content">
                {panel.content.map((item, idx) => (
                  <li key={idx} dangerouslySetInnerHTML={{ __html: item }}></li>
                ))}
              </ul>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="carousel-nav">
          <div className="nav-arrow left" ref={prevElRef}>
            <LeftCircleArrowIcon />
          </div>
          <div className="nav-arrow right" ref={nextElRef}>
            <RightCircleArrowIcon />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerCarousel;
